import { Component } from 'react';

import { Button } from '@iwoca/orion';
import { WarningTriangleSVG } from '@svgComponents/warningTriangleSVG';
import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';

import { TickSVG } from '../../../svgComponents/tickSVG/index';
import { LoadingSpinner } from '../loadingSpinner';
import styles from './ConfirmationButton.module.css';

class ConfirmationButton extends Component {
    isDisabled() {
        const { loading, disabled, status } = this.props;
        return !!(loading || disabled || status === 'error');
    }

    getClassName() {
        const { className, loading, status } = this.props;

        if (loading) {
            return classNames(className, styles.ConfirmationButtonLoading);
        }

        if (status === 'error') {
            return classNames(className, styles.ConfirmationButtonError);
        }

        if (status === 'success') {
            return classNames(className, styles.ConfirmationButtonSuccess);
        }

        return classNames(className, styles.ConfirmationButton);
    }

    renderContent() {
        const { children, loading, status } = this.props;

        if (loading) {
            return (
                <LoadingSpinner
                    data-testid="confirm-button-loading"
                    className={styles.spinner}
                />
            );
        } else if (status === 'error') {
            return (
                <>
                    <WarningTriangleSVG />{' '}
                    <FormattedMessage
                        id="_.confirmation_button.error"
                        defaultMessage="Error"
                    />
                </>
            );
        } else if (status === 'success') {
            return (
                <>
                    <TickSVG />
                </>
            );
        }

        return <>{children}</>;
    }

    render() {
        const {
            onClick,

            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            loading, // Separating out loading to prevent it from being passed to <button> using the ...otherProps, which will lead to a console error
            ...otherProps
        } = this.props;

        const content = this.renderContent();

        return (
            <Button
                {...otherProps}
                className={this.getClassName()}
                disabled={this.isDisabled()}
                onClick={onClick}
            >
                {content}
            </Button>
        );
    }
}

// eslint-disable-next-line import/no-default-export
export default ConfirmationButton;
